module.exports = __webpack_public_path__ + "img/LPTemp4.9a23e449.png";